<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-08-30 15:56:50
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-24 10:31:48
 * @FilePath: /chaoyongtuan/src/views/homePage/home/components/workDepartment/workDepartment.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div class="deptTreeSelect-content" :style="{ borderColor: borderColor }">
			<div class="deptTreeSelect-content-left yx-color-text-regular font-h4-regular">搜部门</div>
			<deptTreeSelect
				class="deptTreeSelect-content-right"
				:collapseTags="true"
				returnArray
				size="small"
				@visibleChange="deptTreeVisibleChange"
				@change="deptChange"
				ref="deptTreeSelect"
			/>
		</div>
	</div>
</template>
<script>
import deptTreeSelect from '@/components/business/deptTreeSelect/deptTreeSelect.vue';
export default {
	components: {
		deptTreeSelect,
	},
	data() {
		return {
			borderColor: '#f0f1f5',
		};
	},
	methods: {
		/**
		 * 点击部门展开下拉
		 */
		deptTreeVisibleChange(val) {
			val && (this.borderColor = '#2475ff');
			!val && (this.borderColor = '#f0f1f5');
		},
		deptChange(val) {
			this.$emit('input', val);
		},
	},
};
</script>
<style lang="less" scoped>
.deptTreeSelect-content {
	position: relative;
	display: flex;
	align-items: center;
	cursor: pointer;
	border: 1px solid @color-gy3;
	border-radius: 4px;
	height: 30px;
	transition: border 0.3s;
	.deptTreeSelect-content-left {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 66px;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		height: 32px;
		box-sizing: border-box;
	}
	.deptTreeSelect-content-left::before {
		content: '';
		display: block;
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		height: 100%;
		width: 1px;
		background-color: @color-gy3;
	}
	/deep/ .deptTreeSelect-content-right .el-input .el-input__inner {
		border: none;
		border-radius: 0px 4px 4px 0px;
		box-sizing: border-box;
		height: 30px !important;
	}
}
.deptTreeSelect-content:hover {
	border-color: #2475ff !important;
}
.deptTreeSelect-content::before {
	content: '';
	display: block;
	position: absolute;
	left: -15px;
	top: 50%;
	transform: translateY(-50%);
	height: 14px;
	width: 1px;
	background-color: #e3e3e3;
}
</style>
